import React from "react";
import "./RegulatoryNotice.css";

const RegulatoryNotice = () => {
  return (
    <div className="regulatory-notice-section">
      <div className="container">
        <div className="regulatory-notice-card">
          <div className="regulatory-notice-header">
            <span className="regulatory-notice-icon" aria-hidden="true">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </span>
            <h4 className="regulatory-notice-title">
              Important Notice: Regulatory Status Update
            </h4>
          </div>
          <div className="regulatory-notice-body">
            <p>
              Peniel Services Limited trading as Buga money is currently not
              conducting any regulated trading activities. We are awaiting formal
              confirmation and authorization from the Financial Conduct
              Authority (FCA).
            </p>
            <p>
              During this period, this website is for informational purposes
              only. It does not constitute an offer, solicitation, or
              invitation to trade or register. We cannot accept new clients or
              process any financial transactions until our FCA status is fully
              approved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegulatoryNotice;
